import styled from 'styled-components';
import { Colors } from '../../../consts';
import { HTMLInputElementBaseSkin } from '../../Field/skins/HTMLInputElementBaseSkin.skin';
export var TextAreaFieldTextAreaSkin = styled(HTMLInputElementBaseSkin.withComponent('textarea')).withConfig({
  displayName: "TextAreaskin__TextAreaFieldTextAreaSkin",
  componentId: "sc-1utnl3i-0"
})(["color:rgba(0,0,0,0.87);padding:16px;padding-top:32px;border:2px solid transparent;border-color:", ";border-width:", ";margin:", ";resize:none;box-sizing:border-box;flex:1 1 auto;"], function (_ref) {
  var disabled = _ref.disabled,
      active = _ref.active,
      showError = _ref.showError;
  return !disabled ? showError ? Colors.RED : active ? Colors.BLUE : '#666' : 'rgba(0, 0, 0, 0.42)';
}, function (_ref2) {
  var active = _ref2.active;
  return active ? '2px' : '1px';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? '-1px' : '-0px';
});